var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 16.5833C13.0389 16.5833 16.5833 13.0389 16.5833 8.66667C16.5833 4.29441 13.0389 0.75 8.66667 0.75C4.29441 0.75 0.75 4.29441 0.75 8.66667C0.75 13.0389 4.29441 16.5833 8.66667 16.5833Z",
    stroke: "#14C7C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 17.4167L15.75 15.75",
    stroke: "#14C7C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentActive);
export default __webpack_public_path__ + "static/media/Assessment-active.415bbcfce951869260f8e84abcf332ad.svg";
export { ForwardRef as ReactComponent };